import { render, staticRenderFns } from "./AvatarSVG.vue?vue&type=template&id=bf0bdb00&name=component-name&"
import script from "./AvatarSVG.vue?vue&type=script&lang=js&"
export * from "./AvatarSVG.vue?vue&type=script&lang=js&"
import style0 from "./AvatarSVG.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports